<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="商品名称" prop="skuName">
          <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="商品编码" prop="skuCode">
          <el-input v-model.trim="searchForm.skuCode" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="SPU编码" prop="spuCode">
          <el-input v-model.trim="searchForm.spuCode" @keyup.enter.native="onSearch" />
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button
          type="primary"
          size="mini"
          @click="moveToOtherList"
          v-permission="`ec-pc-new$productLifeCycle$aboutNew$ListingList$ProductCopywritingOperation`"
          >移至其他清单</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="isShowImport = true"
          v-permission="`ec-pc-new$productLifeCycle$aboutNew$ListingList$ProductCopywritingOperation`"
          >导入</el-button
        >
        <el-button type="primary" size="mini" @click="isShowExport = true">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :span-method="objectSpanMethod"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="39" fixed="left"></el-table-column>
        <el-table-column v-for="(item,index) in columnData" :prop="item.fieldName" :label="item.fieldDesc" min-width="100" :fixed="index < 4 && 'left'" show-overflow-tooltip :key="item.fieldName">
          <template slot-scope="{ row }">
            <template v-if="item.fieldDesc === '图片'">
              <el-button type="text" @click="showImage(row)" v-if="row.picList && row.picList.length">查看</el-button>
            </template>
            <template v-else>
              {{ row[item.fieldName] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)" v-if="row.isProductEdit">编辑</el-button>
            <el-button type="text" class="red-text-btn" @click="handleDelete(row)" v-if="row.isProductEdit">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <el-dialog title="图片查看" :visible.sync="imgVisible" :close-on-click-modal="false" width="50%"><imgShow :imgList="imgList"></imgShow></el-dialog>
    <moveOtherlist :visible.sync="isShowMoveOtherlist" v-if="isShowMoveOtherlist" :listNo="listNo" :selectedRows="selectedRows" @success="getNewTab" />
    <textEdit :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" :listNo="listNo" @success="getNewTab"></textEdit>
    <importExcel :visible.sync="isShowImport" v-if="isShowImport" :data="importCfg" :listNo="listNo" @success="getNewTab"></importExcel>
    <exportExcel :visible.sync="isShowExport" v-if="isShowExport" @exportExcel="exportExcel"></exportExcel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import imgShow from '@/views/components/imgShow';
import textEdit from '../components/textEdit.vue';
import moveOtherlist from './components/moveOtherlist.vue';
import importExcel from './components/importExcel.vue';
import exportExcel from '../components/exportExcel';
import moment from 'moment';
export default {
  name: 'ListingListDetails',
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow, moveOtherlist, textEdit, importExcel, exportExcel },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      imgList: [],
      selectedRows: [],
      isShowEdit: false,
      isShowAddGoods: false,
      isShowMoveOtherlist: false,
      imgVisible: false,
      isShowImport: false,
      isShowExport: false,
      rowData: {},
      importCfg: {},
      searchForm: {
        skuCode: '',
        spuCode: '',
      },
      exportData: {},
      spanArr: [],
    };
  },
  computed: {
    listNo() {
      return this.$route.query.listNo;
    },
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let { skuCode, spuCode } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          listNo: this.listNo,
          type: 2,
          skuCode: skuCode ? skuCode.split(' ') : [],
          spuCode: spuCode ? spuCode.split(' ') : [],
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productListDetailList({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.columnData = [...res.data.titleList];
            const actualExecPriceIndex = this.columnData.findIndex((item) => item.fieldName === 'dailyRetailPrice');
            if (!this.columnData.find((item) => item.fieldName === 'actualExecPrice')) {
              const actualExecPrice = {
                fieldName: 'actualExecPrice',
                fieldDesc: '实际执行价',
              };
              if (actualExecPriceIndex > -1) {
                this.columnData.splice(actualExecPriceIndex + 1, 0, actualExecPrice);
              } else {
                this.columnData.push(actualExecPrice);
              }
            }
            this.tableData = res.data.pageInfo;
            this.computeSpanData(this.tableData.list);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1);
        this.spanIndex = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].spuCode === data[index - 1].spuCode) {
          this.spanArr[this.spanIndex] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.spanIndex = index;
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex == 3 || columnIndex == 4) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1,
        };
      }
    },

    reset() {
      this.searchForm = {
        productCode: '',
        spuCode: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    addGoods() {
      this.isShowAddGoods = true;
    },

    handleEdit(row) {
      this.rowData = row;
      this.isShowEdit = true;
    },

    showImage(row) {
      this.imgList = row.picList.map((v) => v.path);
      this.imgVisible = true;
    },

    moveToOtherList() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择商品');
        return;
      }
      this.isShowMoveOtherlist = true;
      // 实现移至其他清单的逻辑
    },

    handleDelete(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            id: row.id,
            listNo: this.listNo,
            spuCode: row.spuCode,
          };
          this.$q.newProduct.productListDeleteItem({ data: data }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功');
              this.getNewTab();
            }
          });
        })
        .catch(() => {});
    },

    getNewTab() {
      this.$emit('getNumber');
      this.onSearch();
    },

    // 导出
    exportExcel(exportType) {
      const _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.searchFormData.pageSize = 9999999
      this.searchFormData.filterData.exportType = exportType
      this.$q.newProduct.detailListExport({ data: this.searchFormData }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                if(res.data.taskResult == '成功') {
                  let fileName = '产品文案未维护' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                  _this.downloadRes(res.data.filePath, fileName);
                }else{
                  _this.$notify.error({
                    message: res.data.failReason,
                    duration: 0
                  });
                }
                clearInterval(timer);
                loading.close();
              }
            })
            .catch((err) => {
              loading.close();
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName + '' + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
    },

    // 导出
    // exportExcel(exportType) {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)',
    //   });
    //   this.searchFormData.pageSize = 9999999
    //   this.searchFormData.filterData.exportType = exportType
    //   this.$q.newProduct
    //     .detailListExport({
    //       data: this.searchFormData,
    //       options: { responseType: 'blob' },
    //     }).then((res) => {
    //     let fileName = '产品文案未维护' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    //     this.blobDownload(res, `${fileName}.xlsx`);
    //     loading.close();
    //   });
    // },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}

.status-info
  display flex
  span
    margin-right 20px
    cursor pointer
    padding 5px 10px
    border-radius 4px
    transition all 0.3s

    &:hover
      background-color #f0f9eb

    &.active
      background-color #f0f9eb
      color #67c23a
      font-weight bold

    em
      color red
      font-style normal
      font-weight bold
</style>
